import styled from 'styled-components'

const ToastMessageStyled = styled.div`
  position: fixed;
  background-color: ${props => props.theme.colors.white};
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35), 0 0 2px 0 rgba(0, 0, 0, 0.35);
  color: ${props => props.theme.textColorPrimary}; 
  font-size: ${props => props.theme.fontSizeExtraSmall};
  width: 322px;
  top: 35px;
  padding: 8px;
  box-sizing: border-box;
  text-align: center;
`

export default ToastMessageStyled
